import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const eventLevelInformationStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            marginBottom: "60px",
            marginTop: "40px",
        },
        title: {
            color: "#181818",
            fontWeight: 500,
            fontSize: "32px",
            marginBottom: "12px",
        },
        subTitle: {
            color: "#000000",
        },
        smallIndicator: {
            height: "3vh",
            width: "7vh",
            display: "flex",
            alignItems: "center",
            margin: "20px 0px 0px 20px",
        },
    })
);
